(ns rothko.styles.link
  (:require [garden.color :as color]
            [rothko.styles.vars.basic :refer [colours font-sizes font-weights]]))

(def ^:private default-link-color (:orange colours))
(def ^:private active-link-color (color/darken default-link-color 15))

(def default-link-style
  {:text-decoration :underline
   :color default-link-color})

(def default-link-style-modes
  [[:&:active {:color active-link-color}]
   [:&:hover {:color active-link-color}]])

(defn link-styles
  [{:keys [theme] :or {theme :default} :as opts}]
  [:.link default-link-style
   default-link-style-modes])
